import { apiGetAuth, apiPostAuth, apiPutAuth, apiDeleteAuth } from '@/utils/api'
import { API_POLLING_SURVEY, API_USER_MANAGEMENT } from '@/utils/api-url'

import {
  notificationDanger
} from '@/utils/notification'

const state = () => {
  return {
    forms: { data: [] },
    detail_form: {},
    detail_form_response: { data: [] },
    detail_user: { data: []},
    meta_filter: {},
    data_modal_add_edit: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,
      title: '',
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    }
  }
}

const mutations = {
  SET_FORM (state, payload) {
    state.forms = payload
  },
  SET_DETAIL_FORM (state, payload) {
    state.detail_form = payload
  },
  SET_DETAIL_USER (state, payload) {
    state.detail_user = payload
  },
  SET_FORM_DETAIL_RESPONSE (state, payload) {
    state.detail_form_response = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  }
}

const actions = {
  async getListForm(context, payload) {
    try {
      const response = await apiGetAuth(API_POLLING_SURVEY.FORM, payload)
      context.commit('SET_FORM', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getDetailForm(context, payload) {
    try {
      const response = await apiGetAuth(API_POLLING_SURVEY.FORM_DETAIL(payload))
      context.commit('SET_DETAIL_FORM', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async createForm(context, payload) {
    try {
      const response = await apiPostAuth(API_POLLING_SURVEY.FORM, payload)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async updateForm(context, payload) {
    try {
      const response = await apiPutAuth(API_POLLING_SURVEY.FORM_UPDATE_DELETE(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async deleteForm(context, payload) {
    try {
      const response = await apiDeleteAuth(API_POLLING_SURVEY.FORM_UPDATE_DELETE(payload))
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getDetailFormResponse(context, payload) {
    const { id, body } = payload
    try {
      const response = await apiGetAuth(API_POLLING_SURVEY.FORM_DETAIL_RESPONSE(id), body)
      context.commit('SET_FORM_DETAIL_RESPONSE', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async exportReportFormResponse(context, payload) {
    const { id, body } = payload
    try {
      const response = await apiGetAuth(API_POLLING_SURVEY.EXPORT_REPORT_FORM_RESPONSE(id), body)
      if (response.data) {
        return response.data
      }
      return false
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListAllDetailUser (context, payload) {
    try {
      const response = await apiPostAuth(API_USER_MANAGEMENT.ALL_USERNAME, payload)
      context.commit('SET_DETAIL_USER', response.data.data)
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  list_forms (state) {
    return state.forms
  },
  detail_form (state) {
    return state.detail_form
  },
  list_detail_user (state) {
    return state.detail_user
  },
  detail_form_response (state) {
    return state.detail_form_response
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter (state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
